import { Inject, Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse, HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, filter, take, switchMap } from 'rxjs/operators';
import { UsersService } from '../user.service';
import { ApiService } from '../api.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { UtilityService } from '..';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    private isRefreshing = false;
    private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    constructor(public userService: UsersService, public api: ApiService, private http: HttpClient,
        public router: Router, public utility: UtilityService, public spinner: NgxSpinnerService,) { }

    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        const token: any = localStorage.getItem(`token`)
        if (localStorage.getItem(`token`) && JSON.parse(localStorage.getItem('vprpinfo'))) {
            // console.log(`token`, token);
            request = this.addToken(request, localStorage.getItem(`token`));
        }
        return <any>next.handle(request).pipe(catchError(error => {
            if (error instanceof HttpErrorResponse && (error.status === 401)) {
                return this.handle401Error(request, next);
            } else {
                console.log(`error`, error);
                if(error?.error?.statusCode === 400 && error?.error?.statusMessage === 'User already exist') {
                    this.utility.toaster('Error', error.error.statusMessage);
                } else if(error?.error.status === 500) {
                    this.utility.toaster('Error', error?.error.error);
                    this.spinner.hide();
                }
                 else {
                   // this.writeErrorLog(error);
                   if (JSON.parse(localStorage.getItem('vprpinfo'))) {
                    //  window.location.href = 'http://localhost:4300/#/layout/wrong'
                      window.location.href = environment.error_endpoint
                   //window.location.href = 'http://3.108.53.121:8080/PG_PILOT/#/layout/wrong'
                   }
                   // window.location.href = 'http://pg.fintantra.in/PG_UAT/#/layout/wrong'
                }             
                //window.location.href = 'http://169.38.77.181:8080/NRLM_DEVWeb/#/layout/wrong'
                // window.location.href = 'http://169.38.77.181:8080/PG_UAT/#/layout/wrong'
                // window.location.href = 'https://pguat.flexicode.co.in/PGUAT/#/layout/wrong'
                //  return throwError(error);
            }
        }));
    }

    private addToken(request: HttpRequest<any>, token: string) {
        if (request.url.startsWith('http://localhost:4200')
            || request.url.startsWith('http://169.38.77.181:8080/PgUAT2') || request.url.startsWith('http://169.38.77.181:8080/NRLM_DEVWeb') || request.url.startsWith('http://169.38.77.181:8080/NRLM_DEVWeb') || request.url.startsWith('https://pguat.flexicode.co.in/PGUAT') || request.url.startsWith('http://169.38.77.181:8080/NRLM_dev/')
            ||  request.url.startsWith('http://3.108.53.121:8082/NRLM_dev')) {
                // console.log(`inside header`, token)
            return request.clone({
                setHeaders: {
                    'Authorization': `Bearer ${token}`
                }
            });
        }
        return request;
    }

    private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
        if (!this.isRefreshing) {
            this.isRefreshing = true;
            this.refreshTokenSubject.next(null);
            this.userService.refreshToken().then((token: any) => {
                    this.isRefreshing = false;
                    this.refreshTokenSubject.next(token.token);
                    return next.handle(this.addToken(request, token.token));
                });
        } else {
            return this.refreshTokenSubject.pipe(
                filter(token => token != null),
                take(1),
                switchMap(jwt => {
                    return next.handle(this.addToken(request, localStorage.getItem(`token`)));
                }));
        }
    }

    writeErrorLog(error) {
        // console.log(`error.error.path.length`, error.error.path.length);
        const userInfo = JSON.parse(localStorage.getItem('vprpinfo'));
        const lang: any = localStorage.getItem(`selectedLang`);
        let selLang = JSON.parse(lang);
        const obj = {
            "_excplog_gid": 0,
            "_pg_id": '',
            "_role_code": this.api.getParams().userCode,
            "_user_code": this.api.getParams().userCode,
            "_mobile_no": userInfo ? userInfo.mobNumPrimary : '',
            "_excp_date": error.error.timestamp ? error.error.timestamp : null,
            "_excp_from": error.error.path.length == 0 ? '' : error.error.path,
            "_excp_code": error.error.status,
            "_excp_text": error.error.error,
            "_lang_code": selLang.lang_code,
            "_mode_flag": "I",
            "_succ_msg": "",
        }
        const reqHeader = {
            "_user_code": userInfo.loginId,
            "_user_token": "",
            "_url": '/saveExcplog',
            "_succ_msg": ""
        }
        this.http.post(`${environment.endpoint}/${'iudUsertoken'}`, JSON.stringify(reqHeader), { headers: this.iudgetHeaders('/iudUsertoken') }).subscribe(async (res: any) => {
            if (res) {
                await this.api.withOutLang(`/saveExcplog@${res.myArrayList[0].map._user_token}`, obj).subscribe(res => {
                    // if(res) {

                    // } else {
                    //     localStorage.clear();
                    //     sessionStorage.clear();
                    //     this.router.navigate(['/auth']);
                    // }

                }, (err: any) => {
                    localStorage.clear();
                    sessionStorage.clear();
                    this.router.navigate(['/auth']);

                })
            }
        });
    }


    iudgetHeaders(url) {
        const userInfo = JSON.parse(localStorage.getItem('vprpinfo'));
        let headerValue = {};
        const token = localStorage.getItem(`token`);
        headerValue = {
            'Content-Type': 'application/json',
            'Content-Security-Policy': "default-src 'self'; style-src 'self' fonts.googleapis.com; font-src fonts.gstatic.com",
            'X-Tenant-Identifier': 'dynamic_lokos',
            'Authorization': token ? 'Bearer ' + token : '',
            'Cache-Control': 'no-cache, no-store, must-revalidate, post- check=0, pre-check=0',
            'Pragma': 'no-cache',
            'Expires': '0',
            // "Referrer-Policy": "no-referrer, strict-origin-when-cross-origin",
            // "Strict-Transport-Security": "max-age=63072000; includeSubDomains",
            // "X-Content-Type-Options": "nosniff",
            "X-Frame-Options": "DENY",
            // "X-XSS-Protection": "1; mode=block",
            '_url': url,
            '_user_token': '',
            'userCode': userInfo.loginId,
            'roleCode': '',
            'blockCode': '',
        }
        return new HttpHeaders(headerValue);
    }
}
